import * as React from 'react';
import { Store } from 'redux';
import {
	RootPage,
	RootPageLoadData,
	CataloguePage,
	CataloguePageLoadData,
	InstorePage,
	InstorePageLoadData,
	RulesPage,
	TintingPage,
	CategoriesListingPage,
	CategoriesListingPageLoadData,
} from 'pages';
import { InstoreServicesRoutes } from './instore-services-routes';

export type Route = {
	key: React.Key;
	component?: React.ComponentType;
	path: string | string[];
	exact?: boolean;
	strict?: boolean;
	loadData?: (store: Store, url: string) => Promise<void>;
	routes?: Route[];
};

export type RootRoute = Route & {
	routes: Route[];
};

export const routes: RootRoute[] = [
	{
		key: 'root',
		component: RootPage,
		path: '/',
		loadData: RootPageLoadData,
		routes: [
			{
				key: 'catalogue',
				component: CataloguePage,
				path: '/uslugi/catalogue/',
				loadData: CataloguePageLoadData,
				exact: true,
				strict: true,
			},
			{
				key: 'categories-listing',
				component: CategoriesListingPage,
				path: '/uslugi/catalogue/:category',
				loadData: CategoriesListingPageLoadData,
				exact: true,
				strict: false,
			},
			{
				key: 'tinting',
				component: TintingPage,
				path: '/uslugi/kak-zakazat-besplatnuyu-kolerovku-onlayn/',
				exact: true,
				strict: true,
			},
			{
				key: 'instore',
				component: InstorePage,
				path: [
					'/uslugi/uslugi-v-magazinah/',
					'/uslugi/uslugi-v-magazinah/:shop',
					...InstoreServicesRoutes,
				],
				loadData: InstorePageLoadData,
				exact: true,
				strict: false,
			},
			{
				key: 'rules',
				component: RulesPage,
				path: ['/pravila/uslugi/', '/pravila/uslugi/:type'],
				exact: true,
				strict: false,
			},
		],
	},
];
